import Logo from "@/components/Logo/Logo";
import Sidebar, { SidebarItem } from "@/components/Sidebar/Sidebar";
import useProfile from "@/hooks/useProfile";
import {
  BuildingFilled,
  CertificateRegular,
  PersonCircleFilled,
  TaskListLtrRegular,
  TextBulletListSquareFilled,
} from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";

function AdminSidebar() {
  const { t } = useTranslation();
  const { isRoleZero } = useProfile();

  const assessmentItems: SidebarItem[] = [
    {
      label: t("assessment-tests"),
      children: [
        {
          label: t("all-assessments"),
          href: "/console/all-assessments",
        },
        {
          label: t("check-submissions"),
          href: "/console/check-submissions",
        },
        {
          label: t("re-assessments"),
          href: "/console/re-assessments",
        },
      ],
      Icon: TaskListLtrRegular,
    },
    {
      label: t("certification"),
      href: "/console/certifications",
      Icon: CertificateRegular,
    },
  ];

  const companyItems: SidebarItem[] = [
    {
      label: t("company-list"),
      href: "/console/companies",
      Icon: BuildingFilled,
    },
  ];

  const manageItems: SidebarItem[] = [
    {
      label: t("manage-assessments"),
      Icon: TextBulletListSquareFilled,
      children: [
        {
          label: t("simple-assessment"),
          href: "/console/simple-assessments",
        },
        {
          label: t("regular-assessment"),
          href: "/console/regular-assessments",
        },
      ],
    },
  ];

  if (isRoleZero) {
    assessmentItems.push({
      label: t("admin-assessments"),
      children: [
        {
          label: t("confirm-assessments"),
          href: "/console/confirm-assessments",
        },
        {
          label: t("confirm-re-assessments"),
          href: "/console/confirm-re-assessments",
        },
      ],
      Icon: TaskListLtrRegular,
    });
    manageItems.push({
      label: t("assessor-management"),
      href: "/console/assessors",
      Icon: PersonCircleFilled,
    });
  }

  return (
    <div className="flex h-full w-[256px] flex-col gap-2 bg-white shadow-md border-r px-2 pb-3 pt-4">
      <div className="h-[40px] px-2">
        <Logo />
      </div>
      <Sidebar items={assessmentItems} />
      <div className="h-px bg-cyan-500" />
      <Sidebar items={companyItems} />
      <div className="h-px bg-cyan-500" />
      <Sidebar items={manageItems} />
    </div>
  );
}

export default AdminSidebar;
